/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { CarePlanContentInput } from "./CarePlanContentInput";

export interface IncomingCarePlan {
  type: "care_plan";
  content: CarePlanContentInput;
}
